import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchUserDetails } from "../../services/userService"; // Assuming you have a service to fetch user details

interface UserProfileState {
  userDetails: any | null; // Change 'any' to the actual type of user details
  loading: boolean;
  error: string | null;
}

const initialState: UserProfileState = {
  userDetails: null,
  loading: false,
  error: null,
};

export const fetchUserProfile = createAsyncThunk(
  "userProfile/fetchUserProfile",
  async ({ userId, token }: { userId: string; token: string }) => {
    try {
      const userDetails = await fetchUserDetails(userId, token); // Call your service method here to fetch user details
      return userDetails;
    } catch (error: any) {
      throw new Error(error.message); // Throw error to be caught in rejected case
    }
  }
);

const userProfileSlice = createSlice({
  name: "userProfile",
  initialState,
  reducers: {
    removeUserDatils: (state) => {
      state.userDetails = null;
    },
    setUserDeatils: (state, action) => {
      state.userDetails = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUserProfile.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUserProfile.fulfilled, (state, action) => {
        state.loading = false;
        state.userDetails = action.payload;
        state.error = null;
      })
      .addCase(fetchUserProfile.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch user details";
      });
  },
});

export const { setUserDeatils, removeUserDatils } = userProfileSlice.actions;

export default userProfileSlice.reducer;
